module.exports = __webpack_public_path__ + "static/img/protein01.03f4119.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/myprotein-test/assets/images/protein01.png
// module id = +qxw
// module chunks = 0